import 'core-js/stable/number';
import 'core-js/stable/string/repeat';
import Swiper from 'swiper/bundle';

const blogSlider = () => {
  new Swiper('#swiper-blog', {
    slidesPerView: 5,
    spaceBetween: 40,
    centeredSlides: true,
    loop: false,
    grabCursor: true,
    mousewheel: {
      forceToAxis: true,
    },
  });
};

export default blogSlider;
